/**
 * Scrolls the first visible form error (any element marked with
 * `data-form-error`) into view after a failed submit. Without it, an error
 * rendered above the viewport - e.g. a submit button in a sticky bottom bar on
 * a long mobile form - fails silently from the user's point of view.
 *
 * Centered rather than aligned to the top so the message stays clear of
 * sticky headers and sticky footers alike.
 */
export const useScrollToFirstFormError = () => {
  const scrollToFirstFormError = async () => {
    // errors are toggled by the validation that just ran - wait for the DOM
    await nextTick()
    document
      .querySelector('[data-form-error]')
      ?.scrollIntoView({ block: 'center', behavior: 'smooth' })
  }

  return { scrollToFirstFormError }
}
